import {
  BugsnagLight,
  BugsnagLightParams,
  ReleaseStage,
} from '@shopify/bugsnag-light-core';

import {getConfiguration} from 'utilities/configuration';
import {readShopifyFeatures} from 'utilities/shopify-features';

import {InvalidConfigurationError} from './errors';

const BUGSNAG_APP_ID = 'shop_promise_pdp';

const {bugsnagAPIKey, appVersion, releaseStage} = getConfiguration();

const IGNORE_ERRORS = [/failed to fetch/];

const ignoreError = (errorMessage = '') => {
  return IGNORE_ERRORS.some((error) => error.test(errorMessage.toLowerCase()));
};

const defaultParams: BugsnagLightParams = {
  appId: BUGSNAG_APP_ID,
  apiKey: bugsnagAPIKey,
  appType: 'browser',
  releaseStage: releaseStage as ReleaseStage,
  appVersion,
  metadata: {
    shop: {
      id: readShopifyFeatures().shopId,
    },
  },
  onError: (event) => {
    const shouldSend =
      !ignoreError(event.exceptions[0].message) &&
      /**
       * Only report errors that originate from shop_promise_pdp
       */
      event.exceptions.some((exception) =>
        exception.stacktrace.some((frame) => frame.inProject),
      );

    if (releaseStage === 'development') {
      // eslint-disable-next-line no-console
      console.log(
        `%c [ShopPromise] Bugsnag onError [ReleaseStage=${releaseStage}] [ShouldSend=${shouldSend}]`,
        'color: green;',
        event,
      );
    }

    return shouldSend;
  },
};

if (!bugsnagAPIKey) {
  throw new InvalidConfigurationError('Bugsnag API Key is not defined');
}

export const Bugsnag = new BugsnagLight(defaultParams);
